import Comp from './earningsPerShare';

export default Comp;
